import { useState } from "react";
import DoctorPaymentsTab from "./DoctorPaymentsTab";
import PlatformRevenueTab from "./PlatformRevenueTab";
import { PAYMENT_TABS } from "./paymentsUtils";
import "./PaymentsPage.css";

export default function PaymentsPage() {
  const [activePaymentTab, setActivePaymentTab] = useState(
    PAYMENT_TABS.DOCTORS,
  );

  return (
    <div className="payments-page">
      <div className="payments-header">
        <div>
          <h1 className="page-title">Payments</h1>
          <p className="page-subtitle">
            {activePaymentTab === PAYMENT_TABS.DOCTORS
              ? "Manage doctor payments"
              : "Track platform revenue by month"}
          </p>
        </div>
      </div>

      <div className="payments-tabs" role="tablist" aria-label="Payment views">
        <button
          type="button"
          role="tab"
          aria-selected={activePaymentTab === PAYMENT_TABS.DOCTORS}
          className={`payments-tab ${activePaymentTab === PAYMENT_TABS.DOCTORS ? "payments-tab-active" : ""}`}
          onClick={() => setActivePaymentTab(PAYMENT_TABS.DOCTORS)}
        >
          Doctor Payments
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={activePaymentTab === PAYMENT_TABS.REVENUE}
          className={`payments-tab ${activePaymentTab === PAYMENT_TABS.REVENUE ? "payments-tab-active" : ""}`}
          onClick={() => setActivePaymentTab(PAYMENT_TABS.REVENUE)}
        >
          Platform Revenue
        </button>
      </div>

      {activePaymentTab === PAYMENT_TABS.DOCTORS ? (
        <DoctorPaymentsTab />
      ) : (
        <PlatformRevenueTab />
      )}
    </div>
  );
}
